var React = require('react');

function BlueCircle (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"132.77","cy":"132.77","r":"132.77","style":{"fill":"#b4e6ff"}}));
}

BlueCircle.defaultProps = {"viewBox":"0 0 265.55 265.55"};

module.exports = BlueCircle;

BlueCircle.default = BlueCircle;
